export default __webpack_public_path__ + "static/media/sch4.bf375a00.jpg";